import React from 'react';

import { PopupEntryPoint } from '../shared/popup-entry-point';

import { DETAILS_CONFIG } from './dialog-config';
import { entryPoint } from './entrypoint';

export const CollectionAddPaymentDetailsPopup = (): React.JSX.Element => {
	return (
		<PopupEntryPoint
			entryPoint={entryPoint}
			entryPointProps={{}}
			placement={'bottom-end'}
			dialogConfig={DETAILS_CONFIG}
		/>
	);
};
